import z from 'zod';
export const categoryDefinition = z.tuple([z.string(), z.number().optional()]);
export const supertypeSpecs = z.object({
    categories: z.array(categoryDefinition),
    categoryScoreMultiplier: z
        .number()
        .min(0, 'Category score multiplier must be greater than 0')
        .max(1, 'Category score multiplier must be less than 1'),
});
//# sourceMappingURL=supertype.schema.js.map